import { render, staticRenderFns } from "./SPRSimpleDatepickerDashYear.vue?vue&type=template&id=1e3322a0&scoped=true"
import script from "./SPRSimpleDatepickerDashYear.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleDatepickerDashYear.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleDatepickerDashYear.vue?vue&type=style&index=0&id=1e3322a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3322a0",
  null
  
)

export default component.exports